const accessDashboard = {

    DASHBOARD: {
        path: '/dashboard'
    },

    PROFILE: {
        path: '/profile'
    },

    EVENT_LIST: {
        path: '/event-list'
    },

    EVENT_DETAILS: {
        path: '/event-details/:id'
    },

    BUDDIES: {
        path: '/buddies'
    },

    ABOUT_US: {
        path: '/about-us'
    },

    TERMS_CONDITIONS: {
        path: '/terms-of-service'
    },

    TERMS_CONDITIONS_APP: {
        path: '/app-terms-of-service'
    },

    PRIVACY_POLICY: {
        path: '/privacy-policy'
    },

    PRIVACY_POLICY_APP: {
        path: '/app-privacy-policy'
    },

    REFUND_CANCELLATION: {
        path: '/refund-cancellation'
    },

    SHIPPING_DELIVERY: {
        path: '/shipping-delivery'
    },

    HELP_SUPPORT: {
        path: '/help-support'
    },

}

export default accessDashboard;